import type { PostCard_PostData } from '~publish/components/PostCard/PostCard'

const readablePostStatus: Record<PostCard_PostData['status'], string> = {
  draft: 'draft',
  needs_approval: 'needs approval',
  sent: 'sent',
  error: 'errored',
  scheduled: 'scheduled',
  sending: 'being sent',
} as const

export const getReadablePostStatus = (
  status: PostCard_PostData['status'],
): string => {
  return readablePostStatus[status]
}
